import * as yup from "yup";

export type TransFunc = (
  postfix: string,
  variables?: Record<string, unknown>
) => string;

export const emailValidation = (tValidation: TransFunc) =>
  yup
    .string()
    .trim()
    .matches(
      new RegExp(/^[A-Za-z0-9._+\-"]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/, "i"),
      tValidation("error.wrong_email")
    )
    .email(tValidation("error.wrong_email"))
    .nullable()
    .max(225, tValidation("error.too_long_text"));

export const passwordValidationSchema = (tValidation: TransFunc) =>
  yup.string().required(tValidation("error.password_required"));

export const regionsAndCountriesValidationSchema = (tValidation: TransFunc) =>
  yup
    .array()
    .min(1, tValidation("error.select_at_least_one_selection_required"));
